module.exports = __webpack_public_path__ + "static/CE_Overview_Thumbnail-7292bce14ffd7df53b7fa662b8717c35.png";